var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "aspect-ratio-box" }, [
    _c("div", { staticClass: "d-flex justify-content-between" }, [
      _c("div", { staticClass: "font-weight-bold" }, [
        _vm._v(_vm._s(_vm._f("trans")("Continue with"))),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "text-muted font-weight-bold" }),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "continue-btn-box" }, [
      _c(
        "div",
        {
          staticClass: "continue-btn",
          class: { disabled: _vm.complete !== true },
          on: {
            click: function ($event) {
              return _vm.openContinue("aiupscaleimage")
            },
          },
        },
        [
          _c("div", { staticClass: "continue-btn-text" }, [
            _c("i", { staticClass: "far fa-eye" }),
            _vm._v(" " + _vm._s(_vm._f("trans")("Upscale")) + "\n      "),
          ]),
          _vm._v(" "),
          _vm._m(0),
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "continue-btn",
          class: { disabled: _vm.complete !== true },
          on: {
            click: function ($event) {
              return _vm.openContinue("edit")
            },
          },
        },
        [
          _c("div", { staticClass: "continue-btn-text" }, [
            _c("i", { staticClass: "far fa-edit" }),
            _vm._v(" " + _vm._s(_vm._f("trans")("Edit")) + "\n      "),
          ]),
          _vm._v(" "),
          _vm._m(1),
        ]
      ),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", [_c("i", { staticClass: "far fa-arrow-right" })])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", [_c("i", { staticClass: "far fa-arrow-right" })])
  },
]
render._withStripped = true

export { render, staticRenderFns }